// ABOUTME: Exposes the full object schema content type groups to nested edit-node form fields.
// ABOUTME: Used by useFieldProps to resolve select optionsSource references across groups.
import { ContentTypeGroup } from '@src/__generated__/types';
import { createContext } from 'react';

const SchemaContentTypeGroupsContext = createContext<ContentTypeGroup[] | null>(null);

export default SchemaContentTypeGroupsContext;
